import tinymce from "tinymce";

type RegExpFilter = RegExp | [ RegExp, string ] | [ RegExp, (match: string, ...args: any[]) => string ];

const isRegExp = (val: unknown): val is RegExp => val.constructor === RegExp;

const filter = (content: string, items: RegExpFilter[]): string => {
    tinymce.util.Tools.each(items, (v: any) => {
        if (isRegExp(v)) {
            content = content.replace(v, '');
        } else {
            content = content.replace(v[0], v[1] as any);
        }
    });

    return content;
};

const hexToBase64 = function(hex: string) {
    const matches = hex.match(/\w{2}/g);
    if (matches === null) {
        return "";
    }

    return btoa(matches.map(a => String.fromCharCode(parseInt(a, 16))).join(""));
};

const getAllIndexes = (str: string, search: string): number[] => {
    var indexes = [], i = -1;
    while ((i = str.indexOf(search, i+1)) !== -1){
        indexes.push(i);
    }

    return indexes;
}

const clip = (str: string, start: number, end: number): string => {
    return str.slice(0, start) + str.slice(end);
}

export {filter, getAllIndexes, hexToBase64, clip};
